// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ProjectHeader_ProjectFragmentDoc } from '../../ProjectHeader.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type GuidedChangeEventPage_ChangeEventQueryVariables = Types.Exact<{
  changeEventId: Types.Scalars['ID']['input'];
}>;


export type GuidedChangeEventPage_ChangeEventQuery = { __typename?: 'Query', changeEvent: { __typename?: 'ChangeEvent', id: string, title: string, type: { __typename?: 'ChangeEventTypeDetail', code: Types.ChangeEventType }, workflow?: { __typename?: 'ChangeEventWorkflowDetail', code: Types.ChangeEventWorkflow } | null | undefined, reason: { __typename?: 'ChangeEventReason', id: string }, project:
      | { __typename?: 'StandaloneProject', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, siblingProjects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
      | { __typename?: 'Region', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, siblingProjects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
      | { __typename?: 'Market', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, siblingProjects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
      | { __typename?: 'Community', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, siblingProjects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
      | { __typename?: 'Subdivision', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, siblingProjects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
      | { __typename?: 'Lot', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, siblingProjects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
      | { __typename?: 'Structure', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, siblingProjects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
      | { __typename?: 'Unit', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, siblingProjects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
    , materialVariantSwaps: Array<{ __typename?: 'ChangeEventMaterialVariantSwap', id: string, originalProjectItem: { __typename?: 'ProjectItem', id: string }, proposedMaterialVariant: { __typename?: 'MaterialVariant', id: string } }> } };

export type GuidedChangeEventPage_ChangeEventFragment = { __typename?: 'ChangeEvent', id: string, title: string, type: { __typename?: 'ChangeEventTypeDetail', code: Types.ChangeEventType }, workflow?: { __typename?: 'ChangeEventWorkflowDetail', code: Types.ChangeEventWorkflow } | null | undefined, reason: { __typename?: 'ChangeEventReason', id: string }, project:
    | { __typename?: 'StandaloneProject', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Region', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Market', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Community', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Subdivision', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Lot', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Structure', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Unit', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
  , materialVariantSwaps: Array<{ __typename?: 'ChangeEventMaterialVariantSwap', id: string, originalProjectItem: { __typename?: 'ProjectItem', id: string }, proposedMaterialVariant: { __typename?: 'MaterialVariant', id: string } }> };

export type GuidedChangeEventPage_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, shouldAccrueAsComplete: boolean, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string } };

export type GuidedChangeEventPage_Project_Region_Fragment = { __typename?: 'Region', id: string, shouldAccrueAsComplete: boolean, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string } };

export type GuidedChangeEventPage_Project_Market_Fragment = { __typename?: 'Market', id: string, shouldAccrueAsComplete: boolean, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string } };

export type GuidedChangeEventPage_Project_Community_Fragment = { __typename?: 'Community', id: string, shouldAccrueAsComplete: boolean, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string } };

export type GuidedChangeEventPage_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, shouldAccrueAsComplete: boolean, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string } };

export type GuidedChangeEventPage_Project_Lot_Fragment = { __typename?: 'Lot', id: string, shouldAccrueAsComplete: boolean, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string } };

export type GuidedChangeEventPage_Project_Structure_Fragment = { __typename?: 'Structure', id: string, shouldAccrueAsComplete: boolean, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string } };

export type GuidedChangeEventPage_Project_Unit_Fragment = { __typename?: 'Unit', id: string, shouldAccrueAsComplete: boolean, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string } };

export type GuidedChangeEventPage_ProjectFragment =
  | GuidedChangeEventPage_Project_StandaloneProject_Fragment
  | GuidedChangeEventPage_Project_Region_Fragment
  | GuidedChangeEventPage_Project_Market_Fragment
  | GuidedChangeEventPage_Project_Community_Fragment
  | GuidedChangeEventPage_Project_Subdivision_Fragment
  | GuidedChangeEventPage_Project_Lot_Fragment
  | GuidedChangeEventPage_Project_Structure_Fragment
  | GuidedChangeEventPage_Project_Unit_Fragment
;

export const GuidedChangeEventPage_ProjectFragmentDoc = gql`
    fragment GuidedChangeEventPage_Project on Project {
  id
  lotType {
    code
  }
  shouldAccrueAsComplete
  stage(stage: CONSTRUCTION) {
    id
  }
}
    `;
export const GuidedChangeEventPage_ChangeEventFragmentDoc = gql`
    fragment GuidedChangeEventPage_ChangeEvent on ChangeEvent {
  id
  title
  type {
    code
  }
  workflow {
    code
  }
  reason {
    id
  }
  project {
    ...GuidedChangeEventPage_Project
    ...ProjectHeader_Project
  }
  materialVariantSwaps {
    id
    originalProjectItem {
      id
    }
    proposedMaterialVariant {
      id
    }
  }
}
    ${GuidedChangeEventPage_ProjectFragmentDoc}
${ProjectHeader_ProjectFragmentDoc}`;
export const GuidedChangeEventPage_ChangeEventDocument = gql`
    query GuidedChangeEventPage_ChangeEvent($changeEventId: ID!) {
  changeEvent(id: $changeEventId) {
    ...GuidedChangeEventPage_ChangeEvent
  }
}
    ${GuidedChangeEventPage_ChangeEventFragmentDoc}`;

/**
 * __useGuidedChangeEventPage_ChangeEventQuery__
 *
 * To run a query within a React component, call `useGuidedChangeEventPage_ChangeEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuidedChangeEventPage_ChangeEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuidedChangeEventPage_ChangeEventQuery({
 *   variables: {
 *      changeEventId: // value for 'changeEventId'
 *   },
 * });
 */
export function useGuidedChangeEventPage_ChangeEventQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables> & ({ variables: GuidedChangeEventPage_ChangeEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>(GuidedChangeEventPage_ChangeEventDocument, options);
      }
export function useGuidedChangeEventPage_ChangeEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>(GuidedChangeEventPage_ChangeEventDocument, options);
        }
// @ts-ignore
export function useGuidedChangeEventPage_ChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>;
export function useGuidedChangeEventPage_ChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GuidedChangeEventPage_ChangeEventQuery | undefined, GuidedChangeEventPage_ChangeEventQueryVariables>;
export function useGuidedChangeEventPage_ChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>(GuidedChangeEventPage_ChangeEventDocument, options);
        }
export type GuidedChangeEventPage_ChangeEventQueryHookResult = ReturnType<typeof useGuidedChangeEventPage_ChangeEventQuery>;
export type GuidedChangeEventPage_ChangeEventLazyQueryHookResult = ReturnType<typeof useGuidedChangeEventPage_ChangeEventLazyQuery>;
export type GuidedChangeEventPage_ChangeEventSuspenseQueryHookResult = ReturnType<typeof useGuidedChangeEventPage_ChangeEventSuspenseQuery>;
export type GuidedChangeEventPage_ChangeEventQueryResult = ApolloReactCommon.QueryResult<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>;